export default {"src":"/_next/static/media/Case.aa3cf4d8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};